var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8457_921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 18.3337V31.667C11.6667 32.109 11.4911 32.5329 11.1785 32.8455C10.866 33.1581 10.442 33.3337 10 33.3337H6.66667C6.22464 33.3337 5.80072 33.1581 5.48816 32.8455C5.17559 32.5329 5 32.109 5 31.667V20.0003C5 19.5583 5.17559 19.1344 5.48816 18.8218C5.80072 18.5093 6.22464 18.3337 6.66667 18.3337H11.6667ZM11.6667 18.3337C13.4348 18.3337 15.1305 17.6313 16.3807 16.381C17.631 15.1308 18.3333 13.4351 18.3333 11.667V10.0003C18.3333 9.11627 18.6845 8.26842 19.3096 7.6433C19.9348 7.01818 20.7826 6.66699 21.6667 6.66699C22.5507 6.66699 23.3986 7.01818 24.0237 7.6433C24.6488 8.26842 25 9.11627 25 10.0003V18.3337H30C30.8841 18.3337 31.7319 18.6849 32.357 19.31C32.9821 19.9351 33.3333 20.7829 33.3333 21.667L31.6667 30.0003C31.427 31.0228 30.9723 31.9007 30.3711 32.5019C29.7699 33.1031 29.0547 33.395 28.3333 33.3337H16.6667C15.3406 33.3337 14.0688 32.8069 13.1311 31.8692C12.1935 30.9315 11.6667 29.6597 11.6667 28.3337",
    stroke: "#BF4036",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8457_921"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbsUp.05df4275f9b212fbbf4acc1da9c22dc9.svg";
export { ForwardRef as ReactComponent };